// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 720) return "static/chunks/720.b2d9985799a1c5d1.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"59":"277623052de6bebf","236":"898d272d8d445931","627":"b7e3ccbcd13feb8c","756":"65aebe59954e0384"}[chunkId] + ".js";
};